<template>
<div class="error-box">
<h1>404</h1>
<h3 class="h2 mb-3"><i class="fas fa-exclamation-circle"></i> Oops, looks like the page is lost.</h3>
<p class="h4 font-weight-normal">This is not a fault, just an accident that was not intentional.</p>
<router-link to="/market/client" class="btn btn-primary">Back to Deals</router-link>
</div>
</template>
<style>
.content {
  padding: 65px 0 65px 0;
  position: relative;
}

p {
  margin: 0 0 20px;
  font-size: 18px;
  line-height: 28px;
  font-weight: 300;
}

p.large {
  font-size: 20px;
  line-height: 30px;
  font-weight: 300;
  margin-bottom: 55px;
}

img {
  max-width: 100%;
}

.h1,
.h2,
.h3,
.h4,
.h5,
.h6,
h1,
h2,
h3,
h4,
h5,
h6 {
  font-family: inherit;
  font-weight: 400 !important;
  line-height: 1.1;
  color: inherit;
}

h1 {
  font-size: 48px;
}

.centered,
p.large.centered {
  text-align: center;
}
</style>